export default "__VITE_ASSET__864a4847__"